import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/life-ring': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256 504C393 504 504 393 504 256S393 8 256 8 8 119 8 256 119 504 256 504zM152.6 427.3L206 373.9C237.8 387.4 274.1 387.4 306 373.9L359.4 427.3C296.2 465.6 215.8 465.6 152.6 427.3zM336 256C336 300.1 300.1 336 256 336S176 300.1 176 256 211.9 176 256 176 336 211.9 336 256zM427.3 359.4L373.9 306C387.4 274.2 387.4 237.9 373.9 206L427.3 152.6C465.6 215.8 465.6 296.2 427.3 359.4zM359.4 84.7L306 138.1C274.2 124.6 237.9 124.6 206 138.1L152.6 84.7C215.8 46.4 296.2 46.4 359.4 84.7zM84.7 152.6L138.1 206C124.6 237.8 124.6 274.1 138.1 306L84.7 359.4C46.4 296.2 46.4 215.8 84.7 152.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/life-ring.js
// module id = suOE
// module chunks = 144